import React, { useState } from "react";
import FormInput, { CustomFormInputProps } from "./FormInput";
import { InputAdornment, IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const FormInputPassword: React.FC<CustomFormInputProps> = (props) => {
  const [passwordVisible, setPasswordVisible] = useState(false);

  const { t } = useTranslation();

  type HandleClickShowPassword = () => void;
  const handleClickShowPassword: HandleClickShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  type HandleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => void;
  const handleMouseDownPassword: HandleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <FormInput
      {...props}
      type={passwordVisible ? "text" : "password"}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={t("label.togglePassword")}
              onClick={handleClickShowPassword}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {passwordVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FormInputPassword;
